import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch } from "react-redux";
import FormProvider from "../../components/hookForm/FormProvider";
import RHFTextFieldAdd from "../../components/hookForm/RHFTextFieldAdd";
import classNames from "classnames/bind";
import Styles from "./AddUserForm.module.scss";
import { Alert, IconButton, InputAdornment } from "@mui/material";
import { RHFRadioGroup } from "../../components/hookForm";
import { FaPen } from "react-icons/fa";
import { updateUser } from "../../redux/slices/app";
import { useTranslation } from "react-i18next"; // Use `useTranslation` hook
import { FaEye, FaEyeSlash } from "react-icons/fa";

const cx = classNames.bind(Styles);

const EditUserForm = ({ onHide, data }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation(); // Initialize translation hook
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const AddUserSchema = Yup.object().shape({
        fullName: Yup.string().required(t("full_name_required")),
        email: Yup.string()
            .required(t("email_required"))
            .email(t("email_invalid")),
        phone: Yup.string()
            .matches(/^[0-9]+$/, t("phone_numbers_only"))
            .required(t("phone_required")),
        password: Yup.string()
            .min(6, t("password_min_length"))
            .required(t("password_required")),
        confirmPassword: Yup.string()
            .required(t("confirm_password_required"))
            .oneOf([Yup.ref("password"), null], t("passwords_must_match")),
    });

    const methods = useForm({
        resolver: yupResolver(AddUserSchema),
        defaultValues: {
            _id: data._id || "",
            fullName: data.full_name || "",
            email: data.email || "",
            phone: data.phone_number || "",
            password: "",
            confirmPassword: "",
        },
    });

    const {
        reset,
        setError,
        handleSubmit,
        formState: { errors },
    } = methods;

    useEffect(() => {
        reset({
            _id: data._id || "",
            fullName: data.full_name || "",
            email: data.email || "",
            phone: data.phone_number || "",
        });
    }, [data, reset]);

    const onSubmit = async (data) => {
        try {
            dispatch(updateUser(data));
        } catch (err) {
            console.log(err);
            reset();
            setError("afterSubmit", {
                ...err,
                message: err.message,
            });
        }
    };
    const handleClose = (e) => {
        e.preventDefault();
        reset();
        onHide();
    };

    useEffect(() => {
        reset();
    }, [onHide]);
    return (
        <FormProvider
            methods={methods}
            onSubmit={handleSubmit(onSubmit)}
            className={cx("wrapper")}
        >
            <div className={cx("wrapper-input")}>
                <div className={cx("wr-input")}>
                    <span className={cx("input-title")}>{t("full_name")}</span>
                    <RHFTextFieldAdd
                        name="fullName"
                        placeholder={t("add_name_placeholder")}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <FaPen />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
                <div className={cx("wr-input")}>
                    <span className={cx("input-title")}>{t("email")}</span>
                    <RHFTextFieldAdd
                        name="email"
                        type="email"
                        placeholder={t("add_email_placeholder")}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <FaPen />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
                <div className={cx("wr-input")}>
                    <span className={cx("input-title")}>{t("phone_number")}</span>
                    <RHFTextFieldAdd
                        name="phone"
                        placeholder={t("add_phone_number_placeholder")}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <FaPen />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
                <div className={cx("wr-input")}>
                    <span className={cx("input-title")}>{t("current_password")}</span>
                    <RHFTextFieldAdd
                        name="password"
                        type={showPassword ? "text" : "password"}
                        placeholder={t("add_current_password_placeholder")}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                        {showPassword ? <FaEye fontSize={20} /> : <FaEyeSlash fontSize={20} />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
                <div className={cx("wr-input")}>
                    <span className={cx("input-title")}>{t("password")}</span>
                    <RHFTextFieldAdd
                        name="password"
                        type={showPassword ? "text" : "password"}
                        placeholder={t("add_password_placeholder")}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                        {showPassword ? <FaEye fontSize={20} /> : <FaEyeSlash fontSize={20} />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
                <div className={cx("wr-input")}>
                    <span className={cx("input-title")}>{t("confirmPass")}</span>
                    <RHFTextFieldAdd
                        name="confirmPassword"
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder={t("add_re_password_placeholder")}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                                        {showConfirmPassword ? <FaEye fontSize={20} /> : <FaEyeSlash fontSize={20} />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>

                {!!errors.afterSubmit && (
                    <Alert severity="error">{errors.afterSubmit.message}</Alert>
                )}
            </div>

            <div className={cx("footer-btn")}>
                <button className={cx("close-btn")} onClick={onHide}>
                    {t("cancel")}
                </button>
                <button className={cx("submit-btn")}>{t("save_changes")}</button>
            </div>
        </FormProvider>
    );
};

export default EditUserForm;
